// @ts-check
/** @jsx jsx */
import { gql } from '@apollo/client';
import {
  BioDynamicIcon,
  Flex,
  OrganicIcon,
  Text,
  VeganIcon,
  VegetarianIcon,
} from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function ProductCertifications({ product, ...rest }) {
  if (!product) return null;
  const { isVegan, isVegetarian, isCertifiedOrganic, isBiodynamic } = product;

  if (!isVegan && !isVegetarian && !isCertifiedOrganic && !isBiodynamic) {
    return null;
  }

  return (
    <Section title={<Trans>Certifications</Trans>} {...rest}>
      <Flex gap={2}>
        {isVegetarian && (
          <Text>
            <VegetarianIcon />
            <Trans>Vegetarian</Trans>
          </Text>
        )}
        {isVegan && (
          <Text>
            <VeganIcon />
            <Trans>Vegan</Trans>
          </Text>
        )}
        {isCertifiedOrganic && (
          <Text>
            <OrganicIcon
              size="medium"
              sx={{
                color: 'lighterText',
                padding: 1,
                verticalAlign: 'top',
                border: 1,
                borderRadius: 'round',
                borderColor: 'lighterText',
                width: 30,
                height: 30,
                marginY: '2px',
              }}
            />
            <Trans>Organic</Trans>
          </Text>
        )}
        {isBiodynamic && (
          <Text>
            <BioDynamicIcon
              size="medium"
              sx={{
                color: 'lighterText',
                padding: 1,
                verticalAlign: 'top',
                border: 1,
                borderRadius: 'round',
                borderColor: 'lighterText',
                width: 30,
                height: 30,
                marginY: '2px',
              }}
            />
            <Trans>Biodynamic</Trans>
          </Text>
        )}
      </Flex>
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductCertifications on Product {
    isVegan
    isVegetarian
    isCertifiedOrganic
    isBiodynamic
  }
`;

ProductCertifications.fragment = gql`
  fragment ProductCertifications on Product {
    isVegan
    isVegetarian
    isCertifiedOrganic
    isBiodynamic
  }
`;
